import { Controller } from "@hotwired/stimulus";
import { dispatchFilterUpdatedEvent } from "../../datatables/datatable_filters";

export default class extends Controller {
  static targets = ["checkboxInput", "selectAllInput"];
  static outlets = ["datatables--selected-filter"];

  connect() {
    if (this.hasDatatablesSelectedFilterOutlet) {
      this.datatablesSelectedFilterOutlet.displayContent(this._translatedValue());
    }

    this._setSelectAllInput();
  }

  filterChanged() {
    this._setSelectAllInput();
    this.datatablesSelectedFilterOutlet.displayContent(this._translatedValue());
    this._filterUpdated();
  }

  toggleAllFilterSelection(event) {
    this.checkboxInputTargets.forEach((checkbox) => (checkbox.checked = event.currentTarget.checked));
    this.filterChanged();
  }

  _filterUpdated() {
    const { filterName } = this.element.dataset;

    dispatchFilterUpdatedEvent({ name: filterName, keepFilterPanelOpen: true });
  }

  _translatedValue() {
    const selectedCheckboxes = this._selectedCheckboxes();
    if (selectedCheckboxes.length === 0) {
      return null;
    }

    return selectedCheckboxes.map((checkbox) => checkbox.dataset.translatedValue).join(", ");
  }

  _selectedCheckboxes() {
    return this.checkboxInputTargets.filter((checkbox) => checkbox.checked);
  }

  _setSelectAllInput() {
    const selectedValues = this._selectedCheckboxes();
    const allOptionsSelected = selectedValues.length === this.checkboxInputTargets.length;
    this.selectAllInputTarget.indeterminate = selectedValues.length > 0 && !allOptionsSelected;
    this.selectAllInputTarget.checked = allOptionsSelected;
  }
}
